var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-youtube-video"},[_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.playVideo),expression:"playVideo",arg:"tap"},{name:"show",rawName:"v-show",value:(_vm.showOverlay),expression:"showOverlay"}],staticClass:"c-youtube-video__overlay",on:{"click":_vm.playVideo}}),_vm._v(" "),_c('div',{staticClass:"c-youtube-video__iframe",attrs:{"id":((this.uniqId) + "_player")}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c95cb4c8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YoutubeVideo.vue
// module id = 505
// module chunks = 0